import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { FlexLayoutType } from '../../constants/flex-layout.type';

import { PropertyErrorModel } from '../../models/property-error.model';
@Component({
  selector: 'jsg-hearing-associate-materials-upload-error-view',
  templateUrl: './hearing-associate-materials-upload-error-view.component.html',
  styleUrls: ['./hearing-associate-materials-upload-error-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HearingAssociateMaterialsUploadErrorViewComponent {
  @Input() error: PropertyErrorModel;

  public FlexLayoutType = FlexLayoutType;
}
